const alert = {
	/**
	 * Initializes form functions
	 *
	 * @returns {void}
	 */
	init: function () {
		alert.initEvents();
	},

	/**
	 * Initializes event listeners for various form-related events such as change, blur, keyup, and form submission.
	 *
	 * @returns {void}
	 */
	initEvents: function () {
		document.addEventListener(
			'change',
			function (event) {
				for (var target = event.target; target && target != this; target = target.parentNode) {
					if (target.matches('[data-alert] [type=radio]')) {
						alert.alert(event);
						break;
					}
				}
			},
			false
		);
	},

	/**
	 * Displays a warning modal based on the specified conditions and values from the form.
	 *
	 * @param {Event} event - The event triggering the alert functionality.
	 * @returns {void}
	 */
	alert: function (event) {
		const datasetJSON = event.target.closest('[data-actie-werkgever-vraag]').dataset.alert;
		const dataset = JSON.parse(datasetJSON);
		const condition = dataset[0];
		const heading = dataset[1];
		const message = dataset[2];
		const submitButton = event.target.closest('form').querySelector('[type=submit]');
		const value = event.target.closest('.btn-group-toggle').querySelector('[type=radio]:checked').value;
		const modalElement = document.getElementById('modalWaarschuwing');
		const modalElementHeading = modalElement.querySelector('.modal-header .modal-title');
		const modalElementBody = modalElement.querySelector('.modal-body p');

		if (condition == value) {
			submitButton.setAttribute('disabled', 'true');
			modalElementHeading.innerHTML = heading;
			modalElementBody.innerHTML = message;
			const alertModal = new bootstrap.Modal(modalElement);
			alertModal.show();
		} else {
			submitButton.removeAttribute('disabled');
		}
	},
};

export default alert;
